export const VENUE_LIST_PAGE_SIZE = 2000

const pagePath = ({ username, page, pageSize, title, activity }) => {
  const titlePart = title ? `&title=${encodeURIComponent(title)}` : ''
  const activityPart = activity
    ? `&activity=${encodeURIComponent(activity)}`
    : ''
  return `venues/${username}?page=${page}&limit=${pageSize}${titlePart}${activityPart}`
}

/** Every venue the list API will return, past the first page. */
export const fetchEveryVenuePage = async ({
  username,
  title = '',
  activity = '',
  pageSize = VENUE_LIST_PAGE_SIZE,
  get,
} = {}) => {
  if (!username || typeof get !== 'function') return []
  const first = await get(
    'api',
    pagePath({ username, page: 1, pageSize, title, activity }),
  )
  const venues = [...(first?.venues || [])]
  const totalPages = Number(first?.pagination?.totalPages) || 1
  for (let page = 2; page <= totalPages; page += 1) {
    const next = await get(
      'api',
      pagePath({ username, page, pageSize, title, activity }),
    )
    venues.push(...(next?.venues || []))
  }
  return venues
}
